import { render, staticRenderFns } from "./Passes.vue?vue&type=template&id=ece80f12&"
import script from "./Passes.vue?vue&type=script&lang=js&"
export * from "./Passes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports